import _ from 'lodash'

/**
 * If the input level is string, returns the last number in the string separated by commas.
 * If the input level is array, return the last number in array.
 * For null or undefined level returns specified default level.
 * Otherwise returns input level (if level is number for example)
 * @param {*} inputLevel
 * @param {number} defaultLevel
 * @returns {number} Parsed level as number
 */
export const getHighestLevel = (inputLevel, defaultLevel = 10) => {
    if (_.isNil(inputLevel)) return defaultLevel

    // "10,30,50" => 50
    if (typeof inputLevel === 'string') {
        return inputLevel
            .split(',')
            .map((x) => parseInt(x, 10))
            .slice(-1)[0]
    }

    // [10,30,50] => 50
    if (_.isArray(inputLevel)) {
        return inputLevel[inputLevel.length - 1]
    }

    return inputLevel
}
